<script setup lang="ts">
defineProps<{ heading: string }>();
defineSlots<{ default: () => void }>();
</script>

<template>
  <div class="gap-r5 flex flex-col">
    <AppHeading tag="h4" class="text-client-black">{{ heading }}</AppHeading>
    <slot />
  </div>
</template>
